import React from "react";

const TranscriptionDisplay = ({ transcription }) => {
  if (!transcription || transcription === "---") {
    return <p>---</p>;
  }

  const lines = transcription.split("\n").filter(line => line.trim() !== "");

  return (
    <div style={{
      backgroundColor: "#f9f9f9",
      padding: "10px",
      borderRadius: "8px",
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: "14px",
      lineHeight: "1.5"
    }}>
      {lines.map((line, index) => {
        let speaker = "";
        let content = line;

        if (line.toLowerCase().startsWith("agent:")) {
          speaker = "Agent";
          content = line.substring(6).trim();
        } else if (line.toLowerCase().startsWith("client:")) {
          speaker = "Client";
          content = line.substring(7).trim();
        } else {
          speaker = index % 2 === 0 ? "Agent" : "Client";
          content = line.trim();
        }

        return (
          <p key={index} style={{ margin: "5px 0" }}>
            <strong>{speaker}:</strong> {content}
          </p>
        );
      })}
    </div>
  );
};

export default TranscriptionDisplay;
